export const getSourceFromChannelId = (channelId: string) => {
  let source = 'YouTube'

  if (channelId.includes('BitChute')) source = 'BitChute'
  if (channelId.includes('rumble.com')) source = 'Rumble'

  return source
}
